import { IFormFilter } from "src/reducers";
import * as Dtos from "../dtos/Tmd.dtos";

export const
    LoadProjectItemsByProjectId: IProjectItemsLoadByProjectIdActionCreator = (projectId) => {
        return {
            type: ACTION_PROJECTITEMS_LOAD_BY_PROJECT_ID,
            projectId
        }
    },
    LoadSuccess: IProjectItemLoadSuccessActionCreator = (formData, formDataGrouped, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_PROJECTITEM_LOAD_SUCCESS,
            formData,
            formDataGrouped,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IProjectItemLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PROJECTITEM_LOAD_FAILURE,
            responseStatus
        }
    },
    SaveProjectItem: IProjectItemSaveActionCreator = (formData, collectionFormData) => {
        return {
            type: ACTION_PROJECTITEM_SAVE,
            formData,
            collectionFormData
        }
    },
    SaveSuccess: IProjectItemSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_PROJECTITEM_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IProjectItemSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PROJECTITEM_SAVE_FAILURE,
            responseStatus
        }
    },
    CreateProjectItem: IProjectItemCreateActionCreator = (projectId) => {

        return {
            type: ACTION_PROJECTITEM_CREATE,
            projectId
        }
    },
    CreateSuccess: IProjectItemCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_PROJECTITEM_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IProjectItemCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PROJECTITEM_CREATE_FAILURE,
            responseStatus
        }
    },
    Clear: IProjectItemClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_PROJECTITEM_CLEAR,
            propertiesToClear
        }
    },
    Filter: IProjectItemFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_PROJECTITEM_FILTER,
            formFilter
        }
    };

export const
    ACTION_PROJECTITEMS_LOAD_BY_PROJECT_ID = "ACTION_PROJECTITEMS_LOAD_BY_PROJECT_ID",
    ACTION_PROJECTITEM_LOAD_BY_ID = "ACTION_PROJECTITEM_LOAD_BY_ID",
    ACTION_PROJECTITEM_LOAD_SUCCESS = "ACTION_PROJECTITEM_LOAD_SUCCESS",
    ACTION_PROJECTITEM_LOAD_FAILURE = "ACTION_PROJECTITEM_LOAD_FAILURE",

    ACTION_PROJECTITEM_SAVE = "ACTION_PROJECTITEM_SAVE",
    ACTION_PROJECTITEM_SAVE_SUCCESS = "ACTION_PROJECTITEM_SAVE_SUCCESS",
    ACTION_PROJECTITEM_SAVE_FAILURE = "ACTION_PROJECTITEM_SAVE_FAILURE",

    ACTION_PROJECTITEM_CREATE = "ACTION_PROJECTITEM_CREATE",
    ACTION_PROJECTITEM_CREATE_SUCCESS = "ACTION_PROJECTITEM_CREATE_SUCCESS",
    ACTION_PROJECTITEM_CREATE_FAILURE = "ACTION_PROJECTITEM_CREATE_FAILURE",

    ACTION_PROJECTITEM_CLEAR = "ACTION_PROJECTITEM_CLEAR",
    ACTION_PROJECTITEM_FILTER = "ACTION_PROJECTITEM_FILTER";

export interface IProjectItemsLoadByProjectIdAction {
    type: "ACTION_PROJECTITEMS_LOAD_BY_PROJECT_ID";
    projectId: number;
}

export interface IProjectItemsLoadByProjectIdActionCreator {
    (projectId: number): IProjectItemsLoadByProjectIdAction;
}

export interface IProjectItemLoadSuccessAction {
    type: "ACTION_PROJECTITEM_LOAD_SUCCESS";
    formData: Dtos.ProjectItem | Dtos.ProjectItem[];
    formDataGrouped: Dtos.ProjectItemCategory[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectItemLoadSuccessActionCreator {
    (
        formData: Dtos.ProjectItem | Dtos.ProjectItem[],
        formDataGrouped: Dtos.ProjectItemCategory[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IProjectItemLoadSuccessAction;
}

export interface IProjectItemLoadFailureAction {
    type: "ACTION_PROJECTITEM_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectItemLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IProjectItemLoadFailureAction;
}

export interface IProjectItemLoadByIdAction {
    type: "ACTION_PROJECTITEM_LOAD_BY_ID";
    id: number;
}

export interface IProjectItemLoadByIdActionCreator {
    (id: number): IProjectItemLoadByIdAction;
}


export interface IProjectItemSaveAction {
    type: "ACTION_PROJECTITEM_SAVE";
    formData: Dtos.ProjectItem;
    collectionFormData: Dtos.Collection;

}

export interface IProjectItemSaveActionCreator {
    (
        formData: Dtos.ProjectItem,
        collectionFormData: Dtos.Collection
    ): IProjectItemSaveAction;
}

export interface IProjectItemSaveSuccessAction {
    type: "ACTION_PROJECTITEM_SAVE_SUCCESS";
    formData: Dtos.ProjectItem;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectItemSaveSuccessActionCreator {
    (
        formData: Dtos.ProjectItem,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IProjectItemSaveSuccessAction;
}

export interface IProjectItemSaveFailureAction {
    type: "ACTION_PROJECTITEM_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IProjectItemSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IProjectItemSaveFailureAction;
}

export interface IProjectItemCreateAction {
    type: "ACTION_PROJECTITEM_CREATE",
    projectId: number
}

export interface IProjectItemCreateActionCreator {
    (projectId: number): IProjectItemCreateAction
}

export interface IProjectItemCreateSuccessAction {
    type: "ACTION_PROJECTITEM_CREATE_SUCCESS";
    formData: Dtos.ProjectItem;
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
}

export interface IProjectItemCreateSuccessActionCreator {
    (
        formData: Dtos.ProjectItem,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IProjectItemCreateSuccessAction;
}

export interface IProjectItemCreateFailureAction {
    type: "ACTION_PROJECTITEM_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IProjectItemCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IProjectItemCreateFailureAction;
}

export interface IProjectItemClearAction {
    type: "ACTION_PROJECTITEM_CLEAR";
    propertiesToClear?: string[];
}

export interface IProjectItemClearActionCreator {
    (propertiesToClear?: string[]): IProjectItemClearAction;
}

export interface IProjectItemFilterActionCreator {
    (formFilter: IFormFilter): IProjectItemFilterAction;
}

export interface IProjectItemFilterAction {
    type: "ACTION_PROJECTITEM_FILTER";
    formFilter: IFormFilter;
}

export type ProjectItemAction =
    IProjectItemsLoadByProjectIdAction |
    IProjectItemLoadFailureAction |
    IProjectItemLoadSuccessAction |
    IProjectItemSaveAction |
    IProjectItemSaveSuccessAction |
    IProjectItemSaveFailureAction |
    IProjectItemCreateAction |
    IProjectItemCreateSuccessAction |
    IProjectItemCreateFailureAction |
    IProjectItemClearAction |
    IProjectItemFilterAction;
